import { mapGetters } from 'vuex';
import brokerageInfo from '@/common/store/glb/data.brokerage';

export default {
    name: 'agentBrokerage',
    inject: ['$eventBus'],
    props: {
        showAll: {
            type: Boolean,
            default: false
        }
    },
    computed:{
        ...mapGetters('glb', ['glb']),
        currentBrokerage() {
            if(this.showAll){
                return null;
            }
            const key = `${this.glb.geo.cityCode}-${this.glb.geo.stateCode}`;
            if(brokerageInfo[key]){
                return brokerageInfo[key];
            }
            return null;
        }
    },
    data(){
        return {
            brokerageInfo: Object.values(brokerageInfo)
        };
    }
};